import {URL_CONFIG} from "config";

export const AUTH_CONFIG = {
    URL: `${URL_CONFIG.URL}:${URL_CONFIG.AUTH_PORT}/auth`,
    CLIENT_ID: "frontend",
};
